import { Route, Switch } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { MyApplications } from './index';

export const MyApplicationsRoutes = () => (
  <Switch>
    <Route path={ROUTES.APPLICATIONS} exact={true} component={MyApplications} />
  </Switch>
);
